import React, { useState } from 'react';
import { Shield, Zap, CreditCard, Book, Trophy, Sparkles } from 'lucide-react';
const plans = [{
  id: 'esencial',
  icon: <Book className="w-5 h-5" data-id="element-96" />,
  name: 'PLAN ESENCIAL',
  description: '5 tomos + 1 bono',
  originalPrice: '$39.990',
  price: '$19.990',
  featured: false,
  checkoutUrl: 'https://checkout.digitalmarket360.online/cart/42176045318199:1'
}, {
  id: 'completo',
  icon: <Trophy className="w-5 h-5" data-id="element-97" />,
  name: 'SALUD Y ADOLESCENCIA 360',
  description: 'Todos los tomos + todos los bonos',
  originalPrice: '$49.990',
  price: '$24.990',
  featured: true,
  savings: 'AHORRÁS $25.000',
  checkoutUrl: 'https://checkout.digitalmarket360.online/cart/42120499298359:1'
}, {
  id: 'pro',
  icon: <Sparkles className="w-5 h-5" data-id="element-98" />,
  name: 'PACK PRO',
  description: 'Todo del pack 360 + Guía para el aula problemática',
  originalPrice: '$59.990',
  price: '$29.990',
  featured: false,
  checkoutUrl: 'https://checkout.digitalmarket360.online/cart/42120502771767:1'
}];
export function Pricing() {
  const [selected, setSelected] = useState('completo');
  const selectedPlan = plans.find(p => p.id === selected);
  return <section id="compra" className="py-20 bg-brand-darker px-4 scroll-mt-20 border-t border-white/5" data-id="element-99">
      <div className="max-w-2xl mx-auto" data-id="element-100">
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 uppercase" data-id="element-102">
            Elegí tu plan
          </h2>
          <p className="text-lg text-gray-400 font-body" data-id="element-103">
            Dejá de perder tiempo planificando. Volvé a disfrutar el aula.
          </p>
        </div>

        {/* Plan Cards - Stacked */}
        <div className="space-y-3 mb-8" data-id="element-104">
          {plans.map(plan => <button key={plan.id} onClick={() => setSelected(plan.id)} className={`w-full text-left rounded-xl p-5 transition-all duration-200 border-2 ${selected === plan.id ? plan.featured ? 'border-brand-accent bg-brand-accent/5 shadow-lg shadow-brand-accent/10' : 'border-brand-accent/60 bg-brand-card' : 'border-white/10 bg-brand-card hover:border-white/20'}`} data-id="element-105">
              <div className="flex items-center justify-between gap-4" data-id="element-106">
                <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-107">
                  {/* Radio */}
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selected === plan.id ? 'border-brand-accent' : 'border-gray-600'}`} data-id="element-108">
                    {selected === plan.id && <div className="w-2.5 h-2.5 rounded-full bg-brand-accent" data-id="element-109"></div>}
                  </div>

                  <div className="min-w-0" data-id="element-110">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-111">
                      <span className={`${plan.featured ? 'text-brand-accent' : 'text-white'}`} data-id="element-112">
                        {plan.icon}
                      </span>
                      <h3 className={`font-heading font-bold text-base md:text-lg uppercase ${plan.featured ? 'text-brand-accent' : 'text-white'}`} data-id="element-113">
                        {plan.name}
                      </h3>
                    </div>

                    {plan.featured && <div className="flex items-center gap-2 mt-1.5 flex-wrap" data-id="element-114">
                        <span className="bg-brand-accent text-brand-darker text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-115">
                          ⭐ MÁS ELEGIDO
                        </span>
                        <span className="bg-brand-red/20 text-brand-red text-[10px] font-bold px-2 py-0.5 rounded-md border border-brand-red/30" data-id="element-116">
                          {plan.savings}
                        </span>
                      </div>}

                    <p className="text-xs text-gray-400 mt-1 font-body" data-id="element-117">
                      {plan.description}
                    </p>
                  </div>
                </div>

                {/* Price */}
                <div className="text-right flex-shrink-0" data-id="element-118">
                  <p className="text-xs text-gray-500 line-through font-body" data-id="element-119">
                    {plan.originalPrice}
                  </p>
                  <p className={`text-2xl md:text-3xl font-heading font-bold ${plan.featured ? 'text-brand-accent' : 'text-white'}`} data-id="element-120">
                    {plan.price}
                  </p>
                </div>
              </div>
            </button>)}
        </div>

        {/* CTA Button */}
        <a href={selectedPlan?.checkoutUrl || '#'} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-brand-accent hover:bg-brand-accentHover text-brand-darker font-heading font-bold py-4 px-6 rounded-xl transition-colors text-lg shadow-lg shadow-brand-accent/20 uppercase tracking-wide" data-id="element-121">
          SÍ, QUIERO{' '}
          {selected === 'esencial' ? 'EL PLAN ESENCIAL' : selected === 'completo' ? 'SALUD Y ADOLESCENCIA 360' : 'EL PACK PRO'}{' '}
          →
        </a>
        <p className="text-center text-gray-500 text-xs italic mt-3 font-body" data-id="element-122">
          La opción más elegida por docentes de secundaria
        </p>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-8 pt-6 border-t border-white/10 text-gray-400 font-body text-xs" data-id="element-123">
          <div className="flex items-center gap-1.5" data-id="element-124">
            <Shield className="w-4 h-4 text-brand-accent" data-id="element-125" />
            <span data-id="element-126">Pago seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-127">
            <Zap className="w-4 h-4 text-brand-accent" data-id="element-128" />
            <span data-id="element-129">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-130">
            <Shield className="w-4 h-4 text-brand-accent" data-id="element-131" />
            <span data-id="element-132">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-133">
            <CreditCard className="w-4 h-4 text-brand-accent" data-id="element-134" />
            <span data-id="element-135">Mercado Pago</span>
          </div>
        </div>
      </div>
    </section>;
}